<h2 mat-dialog-title>{{ tool.label }}</h2>
<mat-dialog-content class="!p-0">
	<iframe
		[srcdoc]="srcdoc"
		class="w-full border-0"
		style="height: 60vh"
		sandbox="allow-scripts allow-same-origin"></iframe>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button
		mat-button
		(click)="dialogRef.close()">
		Fermer
	</button>
</mat-dialog-actions>
